import { useEffect, useState } from "react";

import { AvgActiveChart } from "../../components/charts3";
import { ChartControls } from "../../components/Channel";

import { useDaysSorted } from "../../hooks/useDaysSorted";
import { useDateInputs } from "../../hooks/useDateInputs";
import { useUserJourneyLogger } from "../../hooks/useUserJourneyLogger";

import { useAvgActiveViewerSeries } from "../../hooks/useAvgActiveViewerSeries";

export default function ChannelAvgActiveVw({ channelId, refreshKey, refreshEnabled, setRefreshEnabled, refreshIntervalMin, setRefreshIntervalMin, refreshCountdown, manualRefresh, rawVideo }) {
  const storedUser = JSON.parse(localStorage.getItem("adm_panel_user") || "{}");
  const defaultMode = storedUser.chartdefault || "minute";
  
  const [mode, setMode] = useState(defaultMode);

  // --- LOGGER INTEGRATION ---
  const { logPageChange, logTimeframeChange } = useUserJourneyLogger({
    channelId,
    // channelName is not available here, so omit or set to undefined
  });

  useEffect(() => {
    logPageChange({
      chartType: "avgactivevw",
    });
  }, [logPageChange]);

  // Only log timeframe change on user-initiated mode change
  const handleModeChange = (newMode) => {
    setMode(newMode);
    logTimeframeChange({
      chartType: "avgactivevw",
      mode: newMode,
    });
  };

  /* --------------------------------
     ✅ TIME STATE (minute / epg only)
  -------------------------------- */
  const [startTime, setStartTime] = useState("00:00");
  const [endTime, setEndTime] = useState("23:59");

  /* --------------------------------
     DATA
  -------------------------------- */
// rawVideo will be received as a prop
  const sortedKeys = useDaysSorted(rawVideo);
  const dates = useDateInputs(sortedKeys, mode);

  const series = useAvgActiveViewerSeries({
    rawVideo,
    sortedVideoKeys: sortedKeys,
    startDateInput: dates.startDateInput,
    endDateInput: dates.endDateInput,
    startTime,
    endTime,
    mode,
  });

  /* --------------------------------
     🔁 RESET TIME WHEN ENTERING MINUTE
  -------------------------------- */
  useEffect(() => {
    if (mode === "minute") {
      setStartTime("00:00");
      setEndTime("23:59");
    }
  }, [mode]);

  /* --------------------------------
     RENDER
  -------------------------------- */
  return (
    <>
      <ChartControls
        channelId={channelId}
        mode={mode}
        onModeChange={handleModeChange}
        startDateInput={dates.startDateInput}
        endDateInput={dates.endDateInput}
        onStartDateChange={dates.setStartDateInput}
        onEndDateChange={dates.setEndDateInput}
        startTime={startTime}
        endTime={endTime}
        onStartTimeChange={setStartTime}
        onEndTimeChange={setEndTime}
        allowedModes={["minute", "hour", "day", "week", "month"]}
        refreshEnabled={refreshEnabled}
        onRefreshToggle={setRefreshEnabled}
        refreshIntervalMin={refreshIntervalMin}
        onRefreshIntervalChange={setRefreshIntervalMin}
        countdown={refreshCountdown}
        onManualRefresh={manualRefresh}
      />

      <AvgActiveChart
        series={series}
        mode={mode}
        title="Average Active Viewers"
      />
    </>
  );
}
